import { render, staticRenderFns } from "./AddDrugBatch.vue?vue&type=template&id=2afb2f9e&scoped=true&lang=pug&"
import script from "./AddDrugBatch.vue?vue&type=script&lang=ts&"
export * from "./AddDrugBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb2f9e",
  null
  
)

export default component.exports